import React from 'react';
import logo from '../assets/images/kabini logo.jpg';

const Header = () => {
  return (
    <section id="welcome-heading" className="pt-5 pb-2">
      <div className="container-fluid padding-side text-center">
        <img 
          src={logo} 
          className="logo img-fluid logo-pulse" 
          style={{ width: '16%', maxWidth: '160px', filter: 'drop-shadow(0 8px 14px #0008CB)' }} 
          alt="Kabini logo"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <br /><br />
        <h2 
          className="display-3 fw-normal animated-underline fw-bold" 
          style={{ 
            color: '#0d9700', 
            textShadow: '0 2px 6px #ffff10', 
            fontFamily: "'Times New Roman', Times, serif", 
            fontWeight: 'bold' 
          }}
        >
          Welcome to Kabini Services
        </h2>
      </div>
    </section>
  );
};

export default Header;